import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Input } from 'reactstrap';
import { Loader } from './../../../components/loader';
import { Checkbox } from './../../../components/checkbox';
import { fetchOrderStore } from '../actions/store';
import { getConsiderProductPriceByTypePrice } from '../../../functions/app';
import { Float } from '../../../functions/input-float';
import _ from 'underscore';
import { Button } from 'antd';

function parseProps(props) {
    return {
        payment_type: props.order.payment_type || 0,
    };
}

class ThirdStage extends Component {
    constructor(props) {
        super(props);
        this.state = parseProps(props);
        this.changeInput = this.changeInput.bind(this);
        this.modalLine = this.modalLine.bind(this);
        this.confirmAction = this.confirmAction.bind(this);
        this.changeCheckbox = this.changeCheckbox.bind(this);
    }

    changeInput(event, key, name) {
        let props = this.props;
        let id = event.target.id;
        let object = {};
        if (key !== undefined) {
            object[id] = this.state[id].concat();
            if (name) {
                object[id][key][name] = event.target.value;
            } else {
                object[id][key] = event.target.value;
            }
        } else {
            object[id] = event.target.value;
            props.setOrderData(id, event.target.value);
        }
        this.setState({ ...object });
    }

    changeCheckbox(payment_type) {
        let props = this.props;
        props.setOrderData('payment_type', payment_type);
        this.setState({
            payment_type: payment_type,
        });
    }

    modalLine(value, id, func, name, md) {
        return (
            <Col xs="12" md={md} className="modal-input-group">
                <Col
                    xs="12"
                    className="col-vl-12 modal-input-group-title text-left"
                >
                    {name}
                </Col>
                <Col xs="12" className="col-vl-12 modal-input-group-input">
                    <Input
                        className="modal-input"
                        value={value}
                        id={id}
                        onChange={func}
                    />
                </Col>
            </Col>
        );
    }

    confirmAction() {
        const props = this.props,
            { dispatch, order } = this.props;

        dispatch(
            fetchOrderStore({
                point_price: order.point.id,

                products: _.map(props.products, (product) => {
                    return {
                        id: product.id,
                        qty: product.qty,
                    };
                }),

                first_name: order.first_name,
                phone: order.phone,
                email: order.email,
                comment: _.reduce(
                    props.setting.rightModal.body.comments,
                    (agg, comment, key) => {
                        let value = (order.comments[key] || '').trim(),
                            prefix = comment.prefix || '';

                        return value.length
                            ? agg +
                                  (agg.length ? ' ' : '') +
                                  (prefix.length ? prefix + ' ' : '') +
                                  value
                            : agg;
                    },
                    ''
                ),
                address: _.reduce(
                    props.setting.rightModal.body.addresses,
                    (agg, address, key) => {
                        let value = (order.addresses[key] || '').trim(),
                            prefix = address.prefix || '';

                        return value.length
                            ? agg +
                                  (agg.length ? ' ' : '') +
                                  (prefix.length ? prefix + ' ' : '') +
                                  value
                            : agg;
                    },
                    ''
                ),
                payment_type: order.payment_type,
                delivery: !!order.delivery,
            })
        );
    }

    render() {
        const props = this.props,
            state = this.state,
            styleObject = {
                active: {
                    background:
                        props.setting.rightModal.body.input.icon.inputNotEmpty
                            .background,
                    color: props.setting.rightModal.body.input.icon
                        .inputNotEmpty.color,
                    borderColor:
                        props.setting.rightModal.body.input.icon.inputNotEmpty
                            .borderColor,
                },
                notActive: {
                    background: props.setting.rightModal.body.input.background,
                    color: props.setting.rightModal.body.input.background,
                    borderColor:
                        props.setting.rightModal.body.input.borderColor,
                },
                label: {
                    color: props.setting.rightModal.body.secondColor,
                },
            },
            styleText = {
                color: props.setting.rightModal.body.secondColor,
            };
        let product_total_price_sum = 0;
        _.each(
            props.products,
            (i) =>
                (product_total_price_sum += Number(
                    Float(
                        Float(Number(i.qty), 3) *
                            Number(
                                getConsiderProductPriceByTypePrice(
                                    i,
                                    props.point.type_price_json,
                                    Number(i.qty),
                                    props.user ? props.user.discount : 0
                                ).price_consider
                            )
                    )
                ))
        );
        return (
            <div className={'shop-case-modal-wrapper'}>
                <div className="modal-scroll shop-case">
                    {props.isFetching ? <Loader /> : null}
                    <div className="mt-3 mb-3 text-center" style={styleText}>
                        Ваш заказ:
                    </div>
                    {props.products.map((item, key) => {
                        let price = getConsiderProductPriceByTypePrice(
                            item,
                            props.point.type_price_json,
                            item.qty,
                            props.user ? props.user.discount : 0
                        ).price_consider;
                        return (
                            <Col
                                xs="12"
                                key={key}
                                className="product-line-review"
                            >
                                <Col
                                    xs="6"
                                    className="d-inline-block"
                                    style={{
                                        color: props.setting.rightModal.body
                                            .secondColor,
                                    }}
                                >
                                    {item.name}
                                </Col>
                                <Col
                                    xs="3"
                                    className="d-inline-block text-center"
                                >
                                    <span
                                        style={{
                                            color: props.setting.rightModal.body
                                                .priceColor,
                                        }}
                                    >
                                        {price}
                                    </span>
                                    <span
                                        style={{
                                            color: props.setting.rightModal.body
                                                .secondColor,
                                        }}
                                    >
                                        {' x '}
                                        {item.qty}
                                    </span>
                                </Col>
                                <Col
                                    xs="3"
                                    className="d-inline-block text-center"
                                    style={{
                                        color: props.setting.rightModal.body
                                            .secondColor,
                                    }}
                                >
                                    {price * item.qty} {props.currency}
                                </Col>
                            </Col>
                        );
                    })}
                    <div className="shop-case-total">
                        <Col
                            xs="8"
                            className="shop-case-total-name"
                            style={styleText}
                        >
                            Сумма заказа:
                        </Col>
                        <Col
                            className="shop-case-total-cash"
                            style={{
                                color: props.setting.rightModal.body.color,
                            }}
                        >
                            {Float(product_total_price_sum)} {props.currency}
                        </Col>
                    </div>
                    <div className="mt-3 text-center" style={styleText}>
                        Оплата:
                    </div>
                    <div className="modal-group w-100 d-flex justify-content-center mt-2">
                        <div>
                            {/* <Checkbox
                                id={'online'}
                                value={state.online}
                                onChange={this.changeCheckbox}
                                caption="Онлайн"
                                styleObject={styleObject}/>*/}
                            <Checkbox
                                className="ml-2"
                                id={'payment_type'}
                                value={state.payment_type === 0}
                                onChange={() => this.changeCheckbox(0)}
                                caption="Наличные"
                                styleObject={styleObject}
                            />
                            <Checkbox
                                className="ml-2"
                                id={'payment_type'}
                                value={state.payment_type === 1}
                                onChange={() => this.changeCheckbox(1)}
                                caption="Картой курьеру"
                                styleObject={styleObject}
                            />
                        </div>
                    </div>
                </div>
                <div
                    className="modal-footer shop-case-footer"
                    style={{
                        background: props.setting.rightModal.footer.background,
                        borderColor:
                            props.setting.rightModal.footer.borderColor,
                    }}
                >
                    <Button
                        xs="12"
                        style={{
                            width: '100%',
                            height: '100%',
                            background:
                                props.setting.rightModal.footer.button
                                    .background,
                            color: props.setting.rightModal.footer.button.color,
                            borderColor:
                                props.setting.rightModal.footer.button
                                    .borderColor,
                        }}
                        onClick={this.confirmAction}
                    >
                        Подтвердить и заказать
                    </Button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = function mapStateToProps(state) {
    return {
        route: state.appState.route,
        setting: state.appState.setting,
        point: state.shopState.order.point,
        user: state.authState.user,
        order: state.shopState.order,
        currency: state.pointsState.currency,
        products: state.shopState.shopCase.products,
        isFetching: state.orderState.storeData.isFetching,
        didInvalidate: state.orderState.storeData.didInvalidate,
    };
};

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        closeModal: function () {
            dispatch({
                type: 'closeRightModal',
            });
        },
        setOrderData: function (nameInput, value) {
            dispatch({
                type: 'set_order_data',
                nameInput: nameInput,
                value: value,
            });
        },
        destroyProduct: function (product_id) {
            dispatch({
                type: 'destroy_product',
                product_id: product_id,
            });
        },
        setProductQty: function (product_id, qty) {
            dispatch({
                type: 'set_product_qty',
                product_id: product_id,
                qty: qty,
            });
        },
        clearShopCase: function () {
            dispatch({
                type: 'clear_shop_case',
            });
        },
        dispatch,
    };
};

export const ThirdStageLink = connect(
    mapStateToProps,
    mapDispatchToProps
)(ThirdStage);
